import BillingDetailForm from "./billingDetailForm.container";

export default BillingDetailForm;
